import styled from 'styled-components';
import { rem } from '@savgroup-front-common/core/src/helpers';

export const $WarrantyTypeContainer = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${rem(8)};
`;

export const $IgnoreDateRulesChecking = styled.span`
  font-size: ${({ theme }) => theme.fonts.size.ultraSmall};
  color: ${({ theme }) => theme.colors.danger};
`;

